import { useMemo } from 'react';

import createNotificationServiceClient from '@swf/core/gql/clients/createNotificationServiceClient';
import useNotificationSubscription from '@swf/core/gql/hooks/useNotificationSubscription';

const NotificationServiceSubscriptions = () => {
  const client = useMemo(() => createNotificationServiceClient(), []);

  useNotificationSubscription(client);

  return null;
};

export default NotificationServiceSubscriptions;
